import { render, staticRenderFns } from "./deliver.vue?vue&type=template&id=3ac5a615&scoped=true"
import script from "./deliver.vue?vue&type=script&lang=js"
export * from "./deliver.vue?vue&type=script&lang=js"
import style0 from "./deliver.vue?vue&type=style&index=0&id=3ac5a615&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac5a615",
  null
  
)

export default component.exports